import type { ReactNode } from "react";
import "./DailyTagCell.scss";
import { scopeForDailyTag } from "@/pages/human-resources/time-management/components/schedule-palette/bottom-row/legend/EntityScope.ts";
import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag.ts";
import classNames from "classnames";
import { Color } from "@/shared/utils/ColorUtils.ts";
import MycawanTooltip from "@/shared/components/generic/tooltip/MycawanTooltip.tsx";

interface Properties {
  dailyTag: DailyTag;
  isDuplicate: boolean;
  selected?: boolean;
  onClick: () => void;
}

export default function DailyTagCell(props: Properties): ReactNode {
  const entityScope =
    props.isDuplicate ? scopeForDailyTag(props.dailyTag) : undefined;

  return (
    <MycawanTooltip title={props.dailyTag.description}>
      <div
        className={classNames(
          "daily-tag-cell",
          props.selected === true && "selected",
          isDarkBackground() && "light-color",
        )}
        style={{ backgroundColor: props.dailyTag.color }}
        onPointerDown={(e) => {
          e.stopPropagation();
          e.preventDefault();
          props.onClick();
        }}
      >
        <div className="label">{props.dailyTag.label}</div>
        {entityScope !== undefined && (
          <div className={`corner-icon ${entityScope}`} />
        )}
      </div>
    </MycawanTooltip>
  );

  function isDarkBackground(): boolean {
    return (
      props.dailyTag.color !== undefined &&
      Color.fromHexaValue(props.dailyTag.color).luminance() < 0.4
    );
  }
}
